import { Component } from '@angular/core'

import { Icon } from '../icon/icon'

@Component({
  selector: 'app-eye-icon',
  imports: [Icon],
  template: `<app-icon
    name="eye"
    [size]="18" />`
})
export class EyeIcon {}

@Component({
  selector: 'app-eye-off-icon',
  imports: [Icon],
  template: `<app-icon
    name="eye-off"
    [size]="18" />`
})
export class EyeOffIcon {}
